export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-en@2x-ea219a92a92d9fd6b745f738526a6712.png";